module.exports = __webpack_public_path__ + "static/media/mother-baby.a6c508a1.svg";